<template>
    <div>
        <div class="title mb-4">
            Atualizar data de lançamentos pela data de emissão <helper-gdb text="Processo de atualização de datas de lançamentos para movimentos com divergências da data de emissão"/>
        </div>
        <v-row>
            <v-col cols="12" sm="12">
                <v-textarea clearable
                    v-model="idmovs"
                    :loading="StateInfoAlunoLoading"
                    :disabled="StateInfoAlunoLoading"
                    hint="Cole os IDMOV separando por VÍRGULA ou ENTER para múltiplas alterações."
                    persistent-hint label="lista de IDMOV's"
                    >
                </v-textarea>
            </v-col>
            <v-col cols="12" sm="12">
                <v-btn 
                    @click.stop="set_data_lancamento"
                    :disabled="(idmovs||'').length <= 1"
                    >Processar movimentos
                </v-btn>
            </v-col>
            <v-col cols="12" sm="12">
                <span v-for="l, index in log" :key="index">
                    <v-alert color="primary">
                        {{l}}
                    </v-alert>
                </span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    data: ()=>({
        idmovs:'',
        log:[],
    }),
    methods:{
        ...mapActions(['SetDataLancamento']),
        async set_data_lancamento(){
            if (!this.idmovs.length){
                alert('Nenhum IDMOV informado!')
            }
            const data = {
                idmovs: this.idmovs,
            }
            const response = await this.SetDataLancamento(data)
            if(response.status == 200){
                this.log = response.data
                this.idmovs = ''
            }else{
                this.log = 'Falha ao processar datas'
                alert(response.statusText)
            }
        },
    },
    computed:{
        ...mapGetters(['StateInfoAlunoLoading'])
    },
    mounted(){
    }
}
</script>
<style scoped>
.cell-text{
    font-size: 11px;
}
</style>
<style>
tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .03);
}
.datatable_caderno_formando tbody{
    vertical-align: text-top !important;
}
.datatable_caderno_formando tbody tr td,.datatable_caderno_formando thead tr th{
    padding: 5px !important;
}
</style>